import { render, staticRenderFns } from "./ServiceSchedule.vue?vue&type=template&id=296c18f6&"
import script from "./ServiceSchedule.vue?vue&type=script&lang=js&"
export * from "./ServiceSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports